'use strict';


module.exports = function ($state, $scope, Department) {
    var _this = this;
    this.selectedTemplate = "";
    this.task = null;

    this.datePopup = false;
    this.endDatePopup = false;
    this.dateOptions = {
        minDate: new Date(),
        showWeeks: false
    };

    this.endDateOptions = {
        minDate: new Date(),
        showWeeks: false
    };

    this.updateEndDates = function () {
        _this.endDateOptions.minDate = _this.task.date;
    };

    this.updateEndDate = function () {
        var hours = _this.task.endDate.getHours();
        var minutes = _this.task.endDate.getMinutes();
        var endDate = new Date(_this.task.startDate);
        endDate.setHours(hours);
        endDate.setMinutes(minutes);
        _this.task.endDate = endDate;
    };


    this.useTemplate = function (value1, value2, value3) {
        this.selectedTemplate = value1;
        this.task = {}
        this.task = value1;
        this.payloadCols = {}
        this.payloadHidden = {}
        this.colnumber = $state.importTasks.colnumber;
        this.task.startDate = new Date();
        this.task.endDate = new Date();
        this.task.endDate = new Date(this.task.endDate.setHours(_this.task.startDate.getHours() + 1));
        this.payloadData = $state.importTasks.data
        if (_this.task.payloadCols == undefined) {
            _this.task.payloadCols = {}
        }
        if (_this.task.payloadHidden == undefined) {
            _this.task.payloadHidden = {}
        }

        this.task.payload.forEach((field, idx) => {
            if (idx < $state.importTasks.colnumber) {
                _this.payloadCols[field] = _this.task.payloadCols[field] || "col" + (idx + 1);
                _this.payloadHidden[field] = _this.task.payloadHidden[field] || false;
            }
        });
    }

    this.getValue = function (value, row = 0, isCoord = false) {
        if (value == undefined) {
            value = "";
        }
        for (var i = 1; i <= $state.importTasks.colnumber; i++) {
            var re = new RegExp("{col".concat(i, "}"), "g");
            value = value.replace(re, $state.importTasks.data[row]["col".concat(i)])
        }
        if (isCoord && !isNaN(parseFloat(value)) && parseFloat(value) == parseInt(value)) {
            let ret = parseFloat(value);
            value = ret * 10 ** -(Math.abs(ret).toString().length - 2);
        }
        return value;
    }

    this.getTemplates = function (value) {
        var query = {
            id: $state.params.departmentId,
            filter: { include: 'form' }
        };

        if (value) {
            query.filter.where = {
                name: {
                    regexp: '/^' + value + '/i'
                }
            };
        }

        return Department.tasktemplate(query)
            .$promise
            .then(function (forms) {
                return forms;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.nextStep = function () {
        $state.importTasks.payloadCols = _this.payloadCols;
        _this.selectedTemplate.payloadCols = _this.payloadCols;
        _this.selectedTemplate.payloadHidden = _this.payloadHidden;
        $state.importTasks.payloadHidden = _this.payloadHidden;
        $state.importTasks.template = _this.task;
        Department.tasktemplate.updateById({
            id: $state.params.departmentId,
            fk: _this.selectedTemplate.id
        }, _this.selectedTemplate)
            .$promise
            .then(function (template) {
                $state.go('dashboard.departments.department.tasksAdvanced.import3');
            })
            .catch(function (error) {
                console.log(error);
            });
    }
};
